<template>
  <div
    :key="posterImage"
    ref="posterImage"
    :class="['poster-image', `poster-ratio-${ratio}`]">
    <!-- Image for various resolutions - Lazyloaded -->
    <picture class="image-wrapper">
      <source
        v-for="(picture, index) in imageData.pictures"
        :key="index"
        :data-srcset="picture.source"
        :media="picture.media"
        :type="picture.type">
      <source
        v-if="posterImage"
        :data-srcset="posterImage"
        type="image/jpeg">
      <!-- Empty inline image to avoid fetching image twice when using lazy loading on some browser (safari/firefox) -->
      <img
        v-if="!hasFailed"
        data-src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D"
        :alt="altImage"
        :class="['image lazyload', { 'fill': !!posterImage }, { 'available': !isLoading }]"
        data-wptv="item-poster"
        width="1600px"
        height="900px"
        @error="onLoadError()"
        @load="onLoadSuccess()">
    </picture>

    <!-- SEO image for no JS crawlers -->
    <!-- Fix nuxt warnings ith inline-template: https://github.com/nuxt/nuxt.js/issues/2582#issuecomment-376446925 -->
    <noscript inline-template>
      <div class="image-wrapper">
      <img
      :src="posterImage"
      :alt="altImage"
      :class="['image available', { 'fill': !!posterImage }]"
      data-wptv="item-poster">
      </div>
    </noscript>
  </div>
</template>

<script>
import _get from 'lodash/get'

export default {
  name: 'PosterImage',
  directives: {
    // Surcharge pour safari qui n'appelle pas le onLoad pour les images en cache
    // du coup les vignettes ne n'affichent pas @see WEBTV-4914
    onComplete (el, { value }) {
      if (el.complete) {
        value()
      }
    }
  },
  props: {
    ratio: {
      type: String,
      required: true
    },
    imageData: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    hasFailed: {
      type: Boolean,
      required: true
    },
    altImage: {
      type: String,
      default: ''
    },
    isAriaHidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    posterImage () {
      return _get(this.imageData, 'image.url')
    }
  },
  mounted () {
    if (this.isAriaHidden) {
      this.setArieHidden()
    }
  },
  methods: {
    setArieHidden () {
      return this.$refs.posterImage.getElementsByTagName('img')[0]?.setAttribute('aria-hidden', 'true')
    },
    onLoadSuccess () {
      this.$emit('load-success', !this.posterImage)
    },
    onLoadError () {
      this.$emit('load-error')
    }
  }
}
</script>

<style lang="scss" scoped>
.poster-image {
  width: 100%;
  position: relative;

  .image-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .image {
      position: absolute;
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
      z-index: 1;
      transition: all 0.5s ease-in-out;
      opacity: 0;

      &.fill {
        width: 100%;
        top: 0;
        left: 0;
      }

      &:not(.fill) {
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
      }

      &.available {
        opacity: 1;
      }
    }
  }

  &.poster-ratio-16-9 {
    padding-top: calc((100% / 16) * 9)
  }

  &.poster-ratio-3-4 {
    padding-top: calc((100% / 3) * 4);
  }
}
</style>
